<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title :class="colorTheme">
          <span class="headline white--text text-uppercase">Add Tranche</span>
        </v-card-title>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
        <v-progress-linear
          v-if="loading"
          :indeterminate="true"
          class="ma-0"
        />

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="title"
                    label="Title"
                    :color="colorTheme"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="fundingTarget"
                    label="Funding Target"
                    :color="colorTheme"
                    type="number"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="primaryMarketSettlement"
                    label="Primary Market Settlement"
                    :rules="requiredRule"
                    :items="settlements"
                    :color="colorTheme"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="distributionChannel"
                    label="Distribution Channel"
                    :rules="requiredRule"
                    :items="distributionChannels"
                    :color="colorTheme"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            :color="colorTheme"
            flat="flat"
            :disabled="processing"
            @click="closeDialog()"
          >
            cancel
          </v-btn>

          <v-btn
            :color="colorTheme"
            flat="flat"
            :disabled="processing"
            @click="submit()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'AddTranche',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    settlements: {
      type: Array,
      default: () => [],
    },
    distributionChannels: {
      type: Array,
      default: () => [],
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
    error: {
      type: String,
      default: '',
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    fpTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: null,
      fundingTarget: null,
      primaryMarketSettlement: null,
      distributionChannel: null,
      valid: true,
      show: this.dialog,
      datePicker: false,
      loading: false,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
      this.title = this.fpTitle;
      if (this.settlements.length === 1) {
        [this.primaryMarketSettlement] = this.settlements;
      }
      if (this.distributionChannels.length === 1) {
        [this.distributionChannel] = this.distributionChannels;
      }
    },
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.submitAction({
          title: this.title,
          fundingTarget: this.fundingTarget,
          primaryMarketSettlement: this.primaryMarketSettlement,
          distributionChannel: this.distributionChannel,
        });
        this.loading = false;
        this.setToDefault();
      }
    },
    closeDialog() {
      this.cancelAction();
      this.setToDefault();
    },
    setToDefault() {
      this.title = null;
      this.fundingTarget = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/AddTranche.vue